const numeric = value => {
  const parsed = Number.parseFloat(value);
  return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
};

// Precautionary app limits, not an official warning or a guarantee of safety.
// Direction alone does not prove that a beach is protected in strong wind.
export const hasStrongWindSafetyStop = (condition = {}) => {
  if (!condition.typhoonAffected) return false;
  const samples = condition.windItems || [];
  const wind = Math.max(numeric(condition.windSpeed), numeric(condition.maxWindSpeed), ...samples.map(item => numeric(item.speed)));
  const gust = Math.max(numeric(condition.windGust), ...samples.map(item => numeric(item.gust)));
  // A site-wide stop is reserved for severe wind during a typhoon influence
  // period. Otherwise use the beach direction and keep leeward coasts visible.
  return wind >= 12 || gust >= 22;
};

const receivedWind = (spot, sample) => {
  const speed = Math.max(numeric(sample.speed), numeric(sample.gust) * 0.65);
  if (!Number.isFinite(spot?.facing) || !Number.isFinite(sample.degree)) return speed;
  const difference = Math.abs(sample.degree - spot.facing) % 360;
  const angle = Math.min(difference, 360 - difference);
  const exposure = angle <= 30 ? 1 : angle <= 60 ? 0.75 : angle <= 90 ? 0.5 : angle <= 120 ? 0.25 : 0.1;
  return speed * exposure;
};

export const getAutomaticBeachCondition = (spot, condition = {}) => {
  if (hasStrongWindSafetyStop(condition)) {
    return { type: "bad", safetyStop: true, reasons: ["wind"] };
  }
  const samples = condition.windItems?.length ? condition.windItems : [{
    speed: condition.windSpeed, gust: condition.windGust, degree: condition.windDegree,
  }];
  const wind = Math.max(0, ...samples.map(sample => receivedWind(spot, sample)));
  const type = wind <= 3 ? "best" : wind <= 4 ? "good" : wind <= 7 ? "caution" : "bad";
  // Beach lounging still uses received wind only, not rainfall or ordinary waves.
  return { type, safetyStop: false, reasons: ["caution", "bad"].includes(type) ? ["wind"] : [] };
};

// Keep the same precedence in map pins, cards, recommendations and voice guide.
export const applySpotConditionOverride = (automatic, manualType, showCaution = false) => {
  if (automatic.safetyStop) return automatic;
  const type = showCaution ? "caution" : manualType;
  if (!["best", "good", "caution", "bad"].includes(type)) return automatic;
  return { ...automatic, type, reasons: ["manual"] };
};
